var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("SwipeContainer", {
    attrs: {
      title: "Swipe right to save an outfit",
      subtext: "We'll show you more outfits like these!",
      type: "like"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0042e9a8", { render: render, staticRenderFns: staticRenderFns })
  }
}